module.exports = __webpack_public_path__ + "img/main-1.e2c6ffe7.svg";